//handles redux exhibitor state
import {createSlice} from '@reduxjs/toolkit';

const initialStateValue = ''

export const fasciaSlice = createSlice({
    name:"fascia",
    initialState:{value:initialStateValue},
    reducers:{
        changeFascia:(state,action)=>{
            state.value = action.payload
        },
    }
})

export const {changeFascia} = fasciaSlice.actions

export default fasciaSlice.reducer;
